import React, { PropsWithChildren, useContext } from 'react';

import { LogDataFormGroupProps, UnitNode } from '../../components';

export interface TabContextValue {
  setLogData?: (unitNode: UnitNode) => LogDataFormGroupProps;
}

const TabContext = React.createContext<TabContextValue>({});
export const useTabContext = () => useContext(TabContext);

export function TabContextProvider({
  children,
  value = {},
}: PropsWithChildren<{ value?: TabContextValue }>) {
  return (
    <TabContext.Provider value={value}>{ children }</TabContext.Provider>
  );
}
